const { checkResolution } = require("./utils/check-resolution");
const { handleProgressBarState } = require("./utils/progress-bar-state");

window.onscroll = () => handleProgressBarState('scroll');
document.addEventListener("resizeEnd.skye", () => handleProgressBarState('resize'));
document.addEventListener("resizeEnd.skye", () => checkResolution());